import { watch } from 'vue-demi';
<template>
    <div class="tab-main">
        <div class="tab-main-title">
               <i class="el-icon-caret-right icon-left" style="flex-shrink: 0"></i>
            {{ tab.name }}</div>
        <ul class="header-statistics">
            <li v-for="(item, index) in tab.statusCount" :key="index" class="header-statistics__item">
                <span class="header-statistics__item-name">{{ item.name }}</span>
                <span class="header-statistics__item-value">{{ item.value }}</span>
            </li>
        </ul>
    </div>

</template>

<script>

export default {
    name: 'Tabs',
    components: {},
    props: {
        tab: {
            type: Object,
            default: () => { },
        },

    },

    data () {
        return {};
    },
    watch: {
        tab: {
            handler (newVal) {
                console.log('tab change', newVal);
            },
            deep: true,
        },
    },
    computed: { },
    methods: { },
    mounted () {
        // console.log(this.data);
    },
};
</script>

<style lang="scss" scoped>
$colorLight: #5bf0fc;

.tab-main {
    display: flex;
    align-items: center;
    .tab-main-title{
        font-size: 16px;
        font-weight: 700;
        margin-left: 80px;
        .icon-left {
            color: #ef8200;
        }
    }
}

.header-statistics {
    display: flex;
    align-items: center;
}

.header-statistics__item {
    display: flex;
    align-items: center;
    margin-left: 16px;
    font-size: 16px;
    min-width: 90px;
    background-image: url("../images/icon-total-bg.svg");
    background-size: 100% 100%;
    padding: 4px 12px;
    background-repeat: no-repeat;
    background-position: center;

    &-name {
        margin-right: 8px;
        height: 20px;
        line-height: 18px;
    }

    &-value {
        color: $colorLight;
        font-size: 20px;
        font-weight: bold;
    }
}
</style>
